import { useEffect } from "react";
import { useStores } from "../../../stores/setup/use-store";
import { CreateAlertFormValues } from "../types";

interface UseAlertCreationUsersSyncParams {
	propsUsersTableSelected?: React.Key[];
	values: CreateAlertFormValues;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export function useAlertCreationUsersSync({
	propsUsersTableSelected,
	values,
	setFieldValue,
}: UseAlertCreationUsersSyncParams) {
	const {
		dataStores: { insightAlertStore },
	} = useStores();

	useEffect(() => {
		if (propsUsersTableSelected && propsUsersTableSelected.length > 0) {
			const selectedUsers = insightAlertStore.operationRuleAlertUserSelected;
			if (selectedUsers.length > 0 && values.selectedUsers.length === 0) {
				setFieldValue("selectedUsers", selectedUsers);
			}
		}
	}, [
		propsUsersTableSelected,
		insightAlertStore.operationRuleAlertUserSelected,
		setFieldValue,
		values.selectedUsers,
	]);
}
